module.exports = __webpack_public_path__ + "static/media/golang.4586c4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/backend/golang.png
// module id = 1517
// module chunks = 0